import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';
import { Device } from '@ionic-native/device';

@Injectable()
export class PedidoProvider {

  constructor(public dbProvider: DatabaseProvider, public device: Device) {
  }

  async update(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'update pedidos set ' +
            '  Cli_Codigo = ?, ' +
            '  Ped_StatusOlimpus = ? ' +
            'WHERE ' +
            '  Ped_Numero = ? ';

          for (let val of data) {
            await tx.executeSql(sql, [val.Cli_Codigo, val.Ped_StatusOlimpus, val.Ped_NumeroApp], (tx, resultSet) => {
              console.log('atualizou pedido');
            }, (err) => {
              console.log('erro atualizar pedido:');
              console.log(err);
            });
          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  async insert(data) {
    return new Promise((resolve, reject) => {
      this.dbProvider.getDB()
        .then((db: SQLiteObject) => {
          db.transaction(async (tx) => {
            let sql = 'insert into pedidos(Cli_Codigo, Ped_Data, Ped_Obs, User_Codigo, Tab_Codigo, Dev_UUID, ' +
              'Fpg_Codigo, Ped_VlrTotal, Ped_VlrDesconto, Ped_VlrLiquido, Ped_Sincronizado, Rot_Codigo) values (?, strftime("%Y-%m-%d", ?), ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)';

            let params = [data.codCliente, data.dataPedido, data.observacoes, data.codUsuario, data.codTabelaPreco, this.device.uuid,
            data.codFormaPgto, (data.vlrTotal + data.vlrDesconto), data.vlrDesconto, data.vlrTotal, 'N', data.codRota];

            let codPedido = 0;
            await tx.executeSql(sql, params, (tx, resultSet) => {
              codPedido = resultSet.insertId;

              let i = 0;
              for (let item of data.produtos) {
                i++;
                let sql2 = 'insert into pedidos_itens(Ped_Numero, PedI_Item, Pro_Codigo, PedI_Qtde, PedI_VlrUnit, PedI_VlrDesconto, PedI_VlrTotal) values (?, ?, ?, ?, ?, ?, ?)';
                let params2 = [codPedido, i, item.codProduto, item.quantidade, item.vlrUnitario, item.vlrDesconto, item.vlrTotal];

                tx.executeSql(sql2, params2, (tx, resultSet) => {
                  console.log('inseriu pedido - item');
                }, (err) => {
                  console.log('erro');
                  console.log(err);
                });
              }

              let p = 0;
              for (let pgto of data.pagamentos) {
                p++;
                let sql3 = 'insert into pedidos_pgto ' +
                  '(Ped_Numero, Ppg_Seq, Ppg_CodFormaPgto, Ppg_Descricao, Ppg_NroDoc, Ppg_Vcto, Ppg_Valor, Ppg_ValorPago, Ppg_ValorTroco, Ppg_TrocoEmHaver, ' +
                  'Ppg_CodCliente, Ppg_NumCheque, Ppg_Agencia, Ppg_CC, Ppg_CPF, Ppg_NomeCheque, Ppg_ContaDB, Ppg_CodBanco) ' +
                  'values ' +
                  '(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)';

                let params3 = [codPedido, p, pgto.codFormaPgto, pgto.descricao, pgto.nroDoc, pgto.vcto, pgto.valor, pgto.valorPago, pgto.valorTroco, pgto.trocoEmHaver,
                  pgto.codCliente, pgto.numCheque, pgto.agencia, pgto.cc, pgto.cpf, pgto.nomeCheque, pgto.contaDB, pgto.codBanco];

                tx.executeSql(sql3, params3, (tx, resultSet) => {
                  console.log('inseriu pedido - pgto');
                }, (err) => {
                  console.log('erro');
                  console.log(err);
                });
              }
              resolve(codPedido);

            }, (err) => {
              console.log('erro:' + err);
            });

          }).then();

        })
        .catch((e) => console.error(e));
    });
  }

  async delete(numPedido) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'DELETE FROM pedidos WHERE Ped_Numero = ?';

          let params = [numPedido];

          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('excluiu pedido');
          }, (err) => {
            console.log('erro:' + err);
          });

          await tx.executeSql('DELETE FROM pedidos_itens WHERE Ped_Numero = ?', [numPedido], (tx, resultSet) => {
            console.log('excluiu produtos do pedido');
          }, (err) => {
            console.log('erro:' + err);
          });

          await tx.executeSql('DELETE FROM pedidos_pgto WHERE Ped_Numero = ?', [numPedido], (tx, resultSet) => {
            console.log('excluiu pagamentos do pedido');
          }, (err) => {
            console.log('erro:' + err);
          });

        }).then();

      })
      .catch((e) => console.error(e));
  }

  async edit(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'update pedidos set Cli_Codigo = ?, Ped_Data = strftime("%Y-%m-%d", ?), Ped_Obs = ?, User_Codigo = ?, Tab_Codigo = ?, ' +
            'Fpg_Codigo = ?, Ped_VlrTotal = ?, Ped_VlrDesconto = ?, Ped_VlrLiquido = ?, Ped_Sincronizado = ?, Rot_Codigo = ? WHERE Ped_Numero = ?';

          let params = [data.codCliente, data.dataPedido, data.observacoes, data.codUsuario, data.codTabelaPreco,
          data.codFormaPgto, (data.vlrTotal + data.vlrDesconto), data.vlrDesconto, data.vlrTotal, 'N', data.codRota, data.codPedido];

          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('editou pedido');
          }, (err) => {
            console.log('erro:' + err);
          });

          await tx.executeSql('DELETE FROM pedidos_itens WHERE Ped_Numero = ?', [data.codPedido], (tx, resultSet) => {
            console.log('excluiu produtos do pedido');
          }, (err) => {
            console.log('erro:' + err);
          });

          await tx.executeSql('DELETE FROM pedidos_pgto WHERE Ped_Numero = ?', [data.codPedido], (tx, resultSet) => {
            console.log('excluiu pagamentos do pedido');
          }, (err) => {
            console.log('erro:' + err);
          });


          let i = 0;
          for (let item of data.produtos) {
            i++;
            let sql2 = 'insert into pedidos_itens(Ped_Numero, PedI_Item, Pro_Codigo, PedI_Qtde, PedI_VlrUnit, PedI_VlrDesconto, PedI_VlrTotal) values (?, ?, ?, ?, ?, ?, ?)';
            let params2 = [data.codPedido, i, item.codProduto, item.quantidade, item.vlrUnitario, item.vlrDesconto, item.vlrTotal];

            await tx.executeSql(sql2, params2, (tx, resultSet) => {
              console.log('inseriu pedido - item');
            }, (err) => {
              console.log('erro:' + err);
            });

          }

          let p = 0;
          for (let pgto of data.pagamentos) {
            p++;
            let sql3 = 'insert into pedidos_pgto ' +
              '(Ped_Numero, Ppg_Seq, Ppg_CodFormaPgto, Ppg_Descricao, Ppg_NroDoc, Ppg_Vcto, Ppg_Valor, Ppg_ValorPago, Ppg_ValorTroco, Ppg_TrocoEmHaver, ' +
              'Ppg_CodCliente, Ppg_NumCheque, Ppg_Agencia, Ppg_CC, Ppg_CPF, Ppg_NomeCheque, Ppg_ContaDB, Ppg_CodBanco) ' +
              'values ' +
              '(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)';

            let params3 = [data.codPedido, p, pgto.codFormaPgto, pgto.descricao, pgto.nroDoc, pgto.vcto, pgto.valor, pgto.valorPago, pgto.valorTroco, pgto.trocoEmHaver,
            pgto.codCliente, pgto.numCheque, pgto.agencia, pgto.cc, pgto.cpf, pgto.nomeCheque, pgto.contaDB, pgto.codBanco];

            tx.executeSql(sql3, params3, (tx, resultSet) => {
              console.log('inseriu pedido - pgto');
            }, (err) => {
              console.log('erro');
              console.log(err);
            });
          }


        }).then();

      })
      .catch((e) => console.error(e));
  }

  async atualizaSincronizados(numPedido = 0) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'update pedidos set Ped_Sincronizado = ? WHERE Ped_Sincronizado = ?';
          let params: any[] = [];
          params = ['S', 'N'];

          if (numPedido > 0) {
            sql += " AND Ped_Numero = ?";
            params.push(numPedido);
          }

          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('atualizou pedidos sincronizados');
          }, (err) => {
            console.log('erro:' + err);
          });

        }).then();

      })
      .catch((e) => console.error(e));
  }

  async atualizaNFCe(numPedido, numNFCe) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'update pedidos set Ped_CodNFCe = ? WHERE Ped_Numero = ?';

          await tx.executeSql(sql, [numNFCe, numPedido], (tx, resultSet) => {
            console.log('atualizou pedido nfce');
          }, (err) => {
            console.log('erro:' + err);
          });

        }).then();

      })
      .catch((e) => console.error(e));
  }


  public getAll(status, dataInicial, dataFinal) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let params = [];
        let sql = 'SELECT p.*, c.Cli_NomeFantasia, C.Cli_Email, Cli_Endereco, Cli_NroEndereco, ' +
          '  Cli_Bairro, Cli_Cidade, Cli_UF, Cli_Complemento, Cli_Fone1 ' +
          'FROM pedidos p ' +
          '  left join clientes c on c.cli_codigo = p.cli_codigo ' +
          'WHERE COALESCE(Ped_StatusOlimpus, ?) <> ? ';
        params.push('P');
        params.push('C');
        if (status != 'T') {
          sql += '  AND Ped_Sincronizado = ?';
          params.push(status);
        }
        if (dataInicial) {
          sql += '  AND Ped_Data BETWEEN ? AND ? ';
          params.push(dataInicial);
          params.push(dataFinal);
        }
        sql += 'order by Ped_Data, Ped_Numero';

        console.log(sql);

        return db.executeSql(sql, params)
          .then((data: any) => {
            if (data.rows.length > 0) {
              let pedidos: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var pedido = new Pedido();
                pedido.codigo = data.rows.item(i).Ped_Numero;
                pedido.codigo_cliente = data.rows.item(i).Cli_Codigo;
                pedido.nome_cliente = data.rows.item(i).Cli_NomeFantasia;
                pedido.email_cliente = data.rows.item(i).Cli_Email;
                pedido.fone_cliente = data.rows.item(i).Cli_Fone1;
                pedido.endereco_cliente = data.rows.item(i).Cli_Endereco;
                pedido.numendereco_cliente = data.rows.item(i).Cli_NroEndereco;
                pedido.bairro_cliente = data.rows.item(i).Cli_Bairro;
                pedido.cidade_cliente = data.rows.item(i).Cli_Cidade;
                pedido.uf_cliente = data.rows.item(i).Cli_UF;
                pedido.complemento_cliente = data.rows.item(i).Cli_Complemento;
                pedido.data = data.rows.item(i).Ped_Data;
                pedido.codigo_rota = data.rows.item(i).Rot_Codigo;
                pedido.codigo_formapgto = data.rows.item(i).Fpg_Codigo;
                pedido.codigo_tabelapreco = data.rows.item(i).Tab_Codigo;
                pedido.codigo_usuario = data.rows.item(i).User_Codigo;
                pedido.sincronizado = data.rows.item(i).Ped_Sincronizado;
                pedido.observacao = data.rows.item(i).Ped_Obs;
                pedido.valor_desconto = data.rows.item(i).Ped_VlrDesconto;
                pedido.valor_total = data.rows.item(i).Ped_VlrTotal;
                pedido.valor_liquido = data.rows.item(i).Ped_VlrLiquido;
                pedido.device = data.rows.item(i).Dev_UUID;
                pedido.codigo_NFCe = data.rows.item(i).Ped_CodNFCe;
                pedidos.push(pedido);
              }
              return pedidos;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  async getProdutos(codPedido) {
    return new Promise((resolve, reject) => {
      this.dbProvider.getDB()
        .then((db: SQLiteObject) => {
          let sql = 'SELECT pi.*, p.Prod_Descricao FROM pedidos_itens pi inner join produtos p on p.prod_codigo = pi.pro_codigo where Ped_Numero = ?';

          db.executeSql(sql, [codPedido])
            .then((data: any) => {
              if (data.rows.length > 0) {
                let produtos: any[] = [];
                for (var i = 0; i < data.rows.length; i++) {
                  var it = new PedidoItem();
                  it.item = data.rows.item(i).PedI_Item;
                  it.codigo_produto = data.rows.item(i).Pro_Codigo;
                  it.nome_produto = data.rows.item(i).Prod_Descricao;
                  it.quantidade = data.rows.item(i).PedI_Qtde;
                  it.preco_unitario = data.rows.item(i).PedI_VlrUnit;
                  it.valor_desconto = data.rows.item(i).PedI_VlrDesconto;
                  it.valor_total = data.rows.item(i).PedI_VlrTotal;

                  produtos.push(it);
                }
                resolve(produtos);
              } else {
                resolve([]);
              }
            })
            .catch((e) => console.error(e));
        })
        .catch((e) => console.error(e));
    });
  }

  async getPgtos(codPedido) {
    return new Promise((resolve, reject) => {
      this.dbProvider.getDB()
        .then((db: SQLiteObject) => {
          let sql = 'SELECT * FROM pedidos_pgto where Ped_Numero = ?';

          db.executeSql(sql, [codPedido])
            .then((data: any) => {
              if (data.rows.length > 0) {
                let pgtos: any[] = [];

                for (var i = 0; i < data.rows.length; i++) {
                  var pg = new PedidoPgto();
                  pg.codFormaPgto = data.rows.item(i).Ppg_CodFormaPgto;
                  pg.descricao = data.rows.item(i).Ppg_Descricao;
                  pg.nroDoc = data.rows.item(i).Ppg_NroDoc;
                  pg.vcto = data.rows.item(i).Ppg_Vcto;
                  pg.valor = data.rows.item(i).Ppg_Valor;
                  pg.valorPago = data.rows.item(i).Ppg_ValorPago;
                  pg.valorTroco = data.rows.item(i).Ppg_ValorTroco;
                  pg.trocoEmHaver = data.rows.item(i).Ppg_TrocoEmHaver;
                  pg.codCliente = data.rows.item(i).Ppg_CodCliente;
                  pg.numCheque = data.rows.item(i).Ppg_NumCheque;
                  pg.agencia = data.rows.item(i).Ppg_Agencia;
                  pg.cc = data.rows.item(i).Ppg_CC;
                  pg.cpf = data.rows.item(i).Ppg_CPF;
                  pg.nomeCheque = data.rows.item(i).Ppg_NomeCheque;
                  pg.contaDB = data.rows.item(i).Ppg_ContaDB;
                  pg.codBanco = data.rows.item(i).Ppg_CodBanco;

                  pgtos.push(pg);
                }
                resolve(pgtos);
              } else {
                resolve([]);
              }
            })
            .catch((e) => console.error(e));
        })
        .catch((e) => console.error(e));
    });
  }

  async getUltimoPedido() {
    return new Promise((resolve, reject) => {
      this.dbProvider.getDB()
        .then((db: SQLiteObject) => {
          let sql = 'SELECT MAX(Ped_Numero) as Ultimo from pedidos';

          db.executeSql(sql, [])
            .then((data: any) => {
              if (data.rows.length > 0) {
                resolve(data.rows.item(0).Ultimo);
              } else {
                resolve(0);
              }
            })
            .catch((e) => console.error(e));
        })
        .catch((e) => console.error(e));
    });
  }

  public exportar(numPedido = 0) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT p.* FROM pedidos p WHERE User_Codigo > 0 AND Ped_Sincronizado = ?';
        let params: any[] = [];
        params.push('N');

        if (numPedido > 0) {
          sql += " AND Ped_Numero = ?";
          params.push(numPedido);
        }

        return db.executeSql(sql, params)
          .then(async (data: any) => {
            if (data.rows.length > 0) {
              let pedidos: any[] = [];
              for (var p = 0; p < data.rows.length; p++) {

                let pedido = new Pedido();
                pedido.codigo = data.rows.item(p).Ped_Numero;
                pedido.codigo_cliente = data.rows.item(p).Cli_Codigo;
                pedido.data = data.rows.item(p).Ped_Data;
                pedido.codigo_formapgto = data.rows.item(p).Fpg_Codigo;
                pedido.codigo_tabelapreco = data.rows.item(p).Tab_Codigo;
                pedido.codigo_rota = data.rows.item(p).Rot_Codigo;
                if (data.rows.item(p).User_Codigo == '' || data.rows.item(p).User_Codigo == null) {
                  pedido.codigo_usuario = 999;
                } else {
                  pedido.codigo_usuario = data.rows.item(p).User_Codigo;
                }
                pedido.sincronizado = data.rows.item(p).Ped_Sincronizado;
                pedido.observacao = data.rows.item(p).Ped_Obs;
                pedido.valor_desconto = data.rows.item(p).Ped_VlrDesconto;
                pedido.valor_total = data.rows.item(p).Ped_VlrTotal;
                pedido.valor_liquido = data.rows.item(p).Ped_VlrLiquido;
                pedido.device = data.rows.item(p).Dev_UUID;
                pedido.nome_cliente = "";
                pedido.itens = [];
                pedido.pagamentos = [];

                let temp = await this.getProdutos(pedido.codigo).then(async (produtos: any[]) => {
                  pedido.itens = produtos;

                  let temp2 = await this.getPgtos(pedido.codigo).then((pgtos: any[]) => {
                    pedido.pagamentos = pgtos;
                    pedidos.push(pedido);
                  });
                });
              }
              return { pedidos: pedidos, contador: data.rows.length };
            } else {
              return { pedidos: [], contador: 0 };
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }


}

export class Pedido {
  codigo: number;
  data: Date;
  device: String;
  codigo_formapgto: number;
  codigo_usuario: number;
  codigo_tabelapreco: number;
  codigo_cliente: number;
  codigo_rota: number;
  nome_cliente: String;
  email_cliente: String;
  endereco_cliente: String;
  numendereco_cliente: String;
  complemento_cliente: String;
  bairro_cliente: String;
  cidade_cliente: String;
  uf_cliente: String;
  fone_cliente: String;
  valor_total: number;
  valor_desconto: number;
  valor_liquido: number;
  observacao: String;
  sincronizado: String;
  codigo_NFCe: Number;
  itens: any[];
  pagamentos: any[];
}

export class PedidoItem {
  item: number;
  codigo_produto: number;
  nome_produto: String;
  quantidade: number;
  preco_unitario: number;
  valor_desconto: number;
  valor_total: number;
}

export class PedidoPgto {
  codFormaPgto: number;
  descricao: String;
  nroDoc: String;
  vcto: Date;
  valor: number;
  valorPago: number;
  valorTroco: number;
  trocoEmHaver: String;
  codCliente: number;
  numCheque: String;
  agencia: String;
  cc: String;
  cpf: String;
  nomeCheque: String;
  contaDB: String;
  codBanco: String;
}




// WEBPACK FOOTER //
// ./src/providers/pedido/pedido.ts